import React from 'react';
import { scrollToOffer } from '../utils/scroll';
export const ProductPresentation: React.FC = () => {
  const chapters = [{
    num: 1,
    title: 'Los Quilates – El Idioma del Oro',
    desc: 'Aprendé la diferencia entre 9k, 14k, 18k, 22k y 24k. Tabla de precios por gramo en USD y pesos. Cómo leer el punzón grabado. Cómo distinguir oro macizo de enchapado, bañado y goldfilled.',
    tags: ['Tabla de quilates', 'Lectura de punzones', 'Trampas comunes']
  }, {
    num: 2,
    title: 'Las 6 Pruebas Para Identificar Oro Real',
    desc: 'Desde la más simple (imán) hasta la más profesional (piedra de toque + ácido). Cada prueba explicada paso a paso con instrucciones de seguridad.',
    tags: ['Imán', 'Cerámica', 'Ácido nítrico', 'Piedra de toque', 'Vinagre', 'Densidad']
  }, {
    num: 3,
    title: 'La Balanza – Tu Herramienta Más Importante',
    desc: 'Qué balanza necesitás (y cuánto cuesta). La regla del 70-80% para fijar tu precio de compra. Cálculo paso a paso con ejemplo real de una operación con ganancia de USD 160.',
    tags: ['Regla 70-80%', 'Caso práctico real', 'Tabla de márgenes']
  }, {
    num: 4,
    title: 'Operatoria Callejera – Cómo Arrancar sin Local',
    desc: 'Dónde encontrar piezas (Facebook, ferias, boca a boca). Guión de negociación probado. Red flags para NO comprar. Cómo transportar y guardar el material.',
    tags: ['Guión de compra', 'Red flags', 'Canales online']
  }, {
    num: 5,
    title: 'Dónde Vender – Las Mejores Salidas del Mercado',
    desc: 'Joyerías en Once, Recoleta, talleres de fundición, compradores mayoristas y reventa directa. Estrategia de negociación para maximizar tu ganancia.',
    tags: ['Once', 'Recoleta', 'Fundición', 'Mayoristas']
  }, {
    num: '6-8',
    title: 'Zonas Clave, Cómo Escalar y Herramientas',
    desc: 'Mapa de zonas activas en CABA y GBA. Cuándo abrir tu propio local. Equipamiento completo con costos. Aspectos legales. Herramientas digitales para calcular precios en tiempo real.',
    tags: ['CABA + GBA', 'Escalar el negocio', 'Herramientas digitales', 'Legalidad']
  }];
  return <section className="py-20" style={{
    background: 'var(--bg-card)'
  }} data-id="element-140">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-141">
        <div className="text-center mb-12" data-id="element-142">
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-3" data-id="element-143">
            Lo que incluye{' '}
            <span style={{
            color: 'var(--gold)'
          }} data-id="element-144">
              "Oro en la Calle"
            </span>
          </h2>
          <p className="text-base" style={{
          color: 'var(--text-secondary)'
        }} data-id="element-145">
            La guía completa para comprar y vender oro en Argentina, desde cero.
          </p>
        </div>

        <div className="space-y-4" data-id="element-146">
          {chapters.map((cap, idx) => <div key={idx} className="rounded-xl p-7 border transition-colors duration-300 hover:border-gold" style={{
          background: 'var(--bg-dark)',
          borderColor: 'var(--border-subtle)'
        }} data-id="element-147">
              <div className="font-serif text-xs font-bold tracking-widest uppercase mb-1.5" style={{
            color: 'var(--gold)'
          }} data-id="element-148">
                {typeof cap.num === 'number' ? `Capítulo ${cap.num}` : `Capítulos ${cap.num}`}
              </div>
              <h3 className="font-bold text-xl mb-2" style={{
            color: 'var(--text-primary)'
          }} data-id="element-149">
                {cap.title}
              </h3>
              <p className="text-sm mb-3 leading-relaxed" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-150">
                {cap.desc}
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-151">
                {cap.tags.map((tag, tIdx) => <span key={tIdx} className="text-xs px-3 py-1 rounded-full border" style={{
              background: 'rgba(200,163,78,0.1)',
              borderColor: 'var(--border-subtle)',
              color: 'var(--gold-light)'
            }} data-id="element-152">
                    {tag}
                  </span>)}
              </div>
            </div>)}
        </div>

        <div className="mt-10 text-center" data-id="element-153">
          <button onClick={scrollToOffer} className="font-bold text-lg px-10 py-4 rounded-md uppercase tracking-widest transition-all duration-300 hover:-translate-y-0.5 w-full sm:w-auto" style={{
          background: 'linear-gradient(135deg, var(--gold), var(--gold-dark))',
          color: 'var(--bg-dark)',
          boxShadow: '0 4px 20px rgba(200,163,78,0.3)'
        }} data-id="element-154">
            QUIERO LA GUÍA COMPLETA
          </button>
        </div>
      </div>
    </section>;
};